module.exports = __webpack_public_path__ + "static/media/ShareTechMono-Regular.972d54ac.ttf";